<template>
<div>
  <v-row no-gutters>
    <v-col :cols="colsMain">

      <v-row class="mgmt-panel">
      <Breadcrumbs :breadcrumbs="breadcrumbs" />

      <v-spacer></v-spacer>
      <MgmtButtons
        :view="view"
        :acl="acl"
        :system="item.system"
        @createItem="createItem"
        @deleteItem="deleteItem"
        @cloneItem="cloneItem"
        @toView="toView"
        @toEdit="toEdit"
        :clone="true"
        :templates="templates"
      />
      </v-row>
      <hr />

      <StaticTabs :selected="activeTab" light class="elevation-0">
        <v-tab href="#info" @click="activeTab = 'info'">Инфо</v-tab>
        <v-tab href="#system" @click="activeTab = 'system'">Системные</v-tab>

        <v-tabs-items v-model="activeTab" touchless>
          <v-tab-item class="tab-item" :style="{ 'max-height': `${tabHeight}px` }" value="info">
            <v-row no-gutters class="tab-row">
              <v-col :cols="cols125">
                <v-card v-if="item.is_template" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="red--text">Шаблон: {{ item.template_name }}</v-card-title>
                </v-card>

                <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Информация</v-card-title>
                  <v-card-text>
                    <table class="view-table" width="100%" >
                      <tr>
                        <th>Номер:</th>
                        <td>{{ item.counter_view }}</td>
                      </tr>
                      <tr>
                        <th>Дата создания:</th>
                        <td>{{ item.date_created }}</td>
                      </tr>

                      <tr>
                        <th>Стоимость:</th>
                        <td>{{ item.price }}</td>
                      </tr>

                      <tr>
                        <th>Пробег:</th>
                        <td>{{ item.mileage }}</td>
                      </tr>
                      <tr>
                        <th>Объект:</th>
                        <td>
                           {{ item.secureobject && item.secureobject.name }}
                         </td>
                      </tr>

                      <tr>
                        <th>Адрес:</th>
                        <td>{{ item.secureobject ? item.secureobject.address_address : '---' }}</td>
                      </tr>

                      <tr>
                        <th>Контрагент:</th>
                        <td>{{ item.secureobject && item.secureobject.client ? item.secureobject.client.name : '---' }}</td>
                      </tr>

                      <tr>
                        <th>Номер договора:</th>
                        <td>{{ item.secureobject && item.secureobject.contract ? item.secureobject.contract.name : '---' }}</td>
                      </tr>
                      <tr>
                        <th>Тип заявки:</th>
                        <td>{{ item.techservice_type ? item.techservice_type.name : '---' }}</td>
                      </tr>

                      <tr>
                        <th class="view-table-list">Технические работы:</th>
                        <td>
                          <ul class="view-table-list">
                            <li v-for="w in item.technical_works" :key="w.id">{{ w.name }}</li>
                          </ul>
                        </td>
                      </tr>


                    </table>
                  </v-card-text>
                </v-card>

                <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Описание</v-card-title>
                  <v-card-text>
                    <div v-if="item.text" class="task-text" v-html="item.text"></div>
                    <div v-else class="no-data">Нет данных</div>
                  </v-card-text>

                  <v-card-text v-if="item.tags && item.tags.length">
                    <v-chip-group
                      active-class="primary--text"
                      column
                    >
                      <v-chip
                        v-for="tag in item.tags"
                        :key="tag.id"
                        small
                      >
                        {{ tag.name }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>

                </v-card>

                <v-card v-if="!item.is_template" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Чеклист</v-card-title>
                    <div class="redactor-field">
                      <CheckList
                        :item="item"
                      ></CheckList>
                    </div>
                </v-card>

                <v-card v-if="!item.is_template" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Файлы</v-card-title>
                    <div class="redactor-field">
                      <MediaList
                        :id="item.id"
                        :acl="acl"
                        :view="view"
                        v-model="item.files"
                      ></MediaList>
                    </div>
                </v-card>
              </v-col>

              <v-col :cols="cols125">

                <v-card v-if="!isNew && !item.is_template" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Статус</v-card-title>
                  <v-card-text>
                    <table class="view-table" width="100%" >
                      <tr>
                        <th>Текущий:</th>
                        <td>{{ item.status_ru }}</td>
                      </tr>
                    </table>
                  </v-card-text>
                </v-card>

                <v-card v-if="!item.is_template" light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-title class="primary--text">Комментарии</v-card-title>
                    <div class="redactor-field">
                      <Comments :url="urlObj" :id="id" :initialComments="item.comments" @setCheckThisOut="setCheckThisOut" :readOnly="true"></Comments>
                    </div>
                </v-card>

              </v-col>

            </v-row>
          </v-tab-item>

          <v-tab-item class="tab-item" :style="{ 'max-height': `${tabHeight}px` }" value="system">
            <v-row no-gutters class="tab-row">
              <v-col :cols="cols125">
                <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                  <v-card-text>
                    <table class="view-table">
                      <tr>
                        <th>Создан:</th>
                        <td>{{ item.created_by_name }}</td>
                      </tr>
                      <tr>
                        <th>Дата создания:</th>
                        <td>{{ item.date_created }}</td>
                      </tr>
                      <tr>
                        <th>Изменен:</th>
                        <td>{{ item.modified_by_name || '---' }}</td>
                      </tr>
                      <tr>
                        <th>Дата изменения:</th>
                        <td>{{ item.date_modified || '---' }}</td>
                      </tr>
                    </table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </StaticTabs>
    </v-col>

  </v-row>
  <Confirmation
    :opened="confirmation.opened"
    :title="confirmation.title"
    :text="confirmation.text"
    :pendingSave="confirmation.pendingSave"
    @confirm="confirmConfirmationAction"
    @cancel="cancelConfirmationAction"
  />
</div>
</template>

<script>
import { get, edit, PREFIX } from '@/api'
import ViewMixin from '@/views/View.vue'
import TaskMixin from '@/views/Task.vue'
import MediaList from '@/components/MediaList'
import Comments from '@/components/Comments'
import CheckList from '@/components/CheckList'

export default {
  mixins: [ViewMixin, TaskMixin],
  components: {
    Comments,
    MediaList,
    CheckList
  },
  props: {
    client_id: {
      type: Number,
      default: null
    },
  },
  computed: {
  },
  data: function () {
    return {
      // default filter
      initialQuery: {
      },

      modelName: 'TechService',
      viewName: 'techservice',
      viewTitle: 'Тех. обслуживание',

      urlList: 'techservices/',
      urlObj: `client/${this.client_id}/personal_area/techservice/`,

      parentHref: `#/personal_area/${this.client_id}/?tab=tech`,

      // item
      item: {
        id: this.id,
        name: '',
        assigneds: [],
        is_assigneds: false,
        available_statuses: [{ name: '', value: null }],
        check_this_persons: {}
      },
      // collbar
      collbar: {
        url: 'techservices/',
        name: 'techservice'
      },
      // pending
      pendingStatus: false,
      // error
      statusError: ''
    }
  },
  methods: {
    setCheckThisOut (data) {
      this.item.check_this_persons = data
    },
  },
}
</script>
<style scoped>
.task-text {
  color: rgba(0, 0, 0, 0.8);
  font-size: 16px;
}
</style>
